
export const createLocalStore = ({root="LocalStorage/"}) => {
	const setItem = (key, value) => {
		localStorage.setItem(key, value);
	};
	const getItem = (key) => {
		return localStorage.getItem(key);
	};
	const removeItem = (key) => {
		localStorage.removeItem(key);
	};

	const setJson = (key, value) => {
		setItem(key, JSON.stringify(value));
	};
	const getJson = (key) => {
		const data = getItem(key);
		return data ? JSON.parse(data) : null;
	};

	const SaveData = root;

	return {
		saveData: (key, value) => { setItem(`${SaveData}${key}`, value); },
		loadData: (key) => { return getItem(`${SaveData}${key}`); },
		deleteData: (key) => { removeItem(key); },
		saveJson: (key, value) => { setJson(`${SaveData}${key}`, value); },
		loadJson: (key) => { return getJson(`${SaveData}${key}`); },
	};
};
